module.exports = __webpack_public_path__ + "img/img-landing-03.a472464c.png";